import { render } from "./Player.vue?vue&type=template&id=522ab76e&scoped=true"
import script from "./Player.vue?vue&type=script&lang=js"
export * from "./Player.vue?vue&type=script&lang=js"

import "./Player.vue?vue&type=style&index=0&id=522ab76e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-522ab76e"

export default script